import { State } from './state';

export const getLoggedInUser = (state: State) => state.entity;
